import React from "react";
import { HoverCard } from "../ResultsPrimitives.jsx";

// Hovercards du Dispatch pour toute la section Geotab : jamais d'infobulle du navigateur (attribut title).
// L'enfant doit être un élément HTML ou SVG (span, button, g…) qui reçoit la référence.
// Largeur ajustée au contenu : le plafond assez large pour qu'une ligne courte ne passe pas à la ligne.
export function Hint({ text, title, placement = "top", children }) {
  if (!text) return children;
  return (
    <HoverCard title={title} content={<p className="m-0 text-slate-700">{text}</p>} placement={placement} delay={120}
      referenceAsChild flat compactTitle maxWidth={420} accentColor="var(--color-accent)">
      {children}
    </HoverCard>
  );
}

export function HoverRows({ title, rows, placement = "top", interactive = false, children }) {
  const content = (
    <dl className="m-0 grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-0.5">
      {rows.filter(Boolean).map(([label, value], i) => (
        <React.Fragment key={i}><dt className="whitespace-nowrap font-semibold text-slate-500">{label}</dt><dd className="m-0 tabular-nums text-slate-800">{value}</dd></React.Fragment>
      ))}
    </dl>
  );
  return (
    <HoverCard title={title} content={content} placement={placement} delay={120} interactive={interactive} openOnTouch={interactive}
      referenceAsChild flat compactTitle maxWidth={480} accentColor="var(--color-accent)">
      {children}
    </HoverCard>
  );
}
